module.exports = __webpack_public_path__ + "img/mechanic-medium.a2b438fd.jpeg";